// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.generated-preview {
    display: flex;
    flex-direction: column;
    align-items: center;

    margin-top: 5vh;
    width: 70vw;
}

.generated-preview h2 {
    font-size: 1.8em;
    margin-bottom: 2vh;
}


.generated-preview-minmax {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
}
.generated-preview-minmax > div {
    display: flex;
    align-items: center;
}
.generated-preview-minmax label {
    font-size: 1.3em;
    font-weight: bold;
    margin-right: 2em;
}

.generated-preview-minmax input {
    width: 3em;
    margin: .5em 0;
    font-size: 1.2em;
    padding: .25em;
}

.generated-preview > h3 {
    margin: 2vh;
    font-size: 1.5em;
}

.generated-preview-records {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: fit-content;
}

.generated-preview-records > div {
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 1em;
    margin: .5em;
    background-color: #4E7B9B;
    color: white;
    border-radius: 12px;

    font-size: 1.3em;
}

.generated-preview-records > div > * {
    margin-top: .5em;
}
.generated-preview-records > div > h3 {
    margin-top: 0;
    text-align: center;
}

.generated-preview-records > div input {
    background-color: #289CEF;
    color: white;
    border: none;
    font-size: 1em;
    border-radius: 12px;
}

.generated-preview-btns  {
    display: flex;
    justify-content: space-around;
    margin: 4vh;
    width: 80%;
    font-size: 1.5em;
}

@media only screen and (width < 1000px) {
    .generated-preview-btns > * {
        margin: 0 2vw;
        font-size: .8em;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/GeneratedPreview.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;;IAEnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;;IAEnB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;;IAEnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,WAAW;IACX,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI;QACI,aAAa;QACb,eAAe;IACnB;AACJ","sourcesContent":[".generated-preview {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    margin-top: 5vh;\n    width: 70vw;\n}\n\n.generated-preview h2 {\n    font-size: 1.8em;\n    margin-bottom: 2vh;\n}\n\n\n.generated-preview-minmax {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    align-items: center;\n}\n.generated-preview-minmax > div {\n    display: flex;\n    align-items: center;\n}\n.generated-preview-minmax label {\n    font-size: 1.3em;\n    font-weight: bold;\n    margin-right: 2em;\n}\n\n.generated-preview-minmax input {\n    width: 3em;\n    margin: .5em 0;\n    font-size: 1.2em;\n    padding: .25em;\n}\n\n.generated-preview > h3 {\n    margin: 2vh;\n    font-size: 1.5em;\n}\n\n.generated-preview-records {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    width: fit-content;\n}\n\n.generated-preview-records > div {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    padding: 1em;\n    margin: .5em;\n    background-color: #4E7B9B;\n    color: white;\n    border-radius: 12px;\n\n    font-size: 1.3em;\n}\n\n.generated-preview-records > div > * {\n    margin-top: .5em;\n}\n.generated-preview-records > div > h3 {\n    margin-top: 0;\n    text-align: center;\n}\n\n.generated-preview-records > div input {\n    background-color: #289CEF;\n    color: white;\n    border: none;\n    font-size: 1em;\n    border-radius: 12px;\n}\n\n.generated-preview-btns  {\n    display: flex;\n    justify-content: space-around;\n    margin: 4vh;\n    width: 80%;\n    font-size: 1.5em;\n}\n\n@media only screen and (width < 1000px) {\n    .generated-preview-btns > * {\n        margin: 0 2vw;\n        font-size: .8em;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
